import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/default-pic.png'
import _imports_1 from '@/assets/images/close-black-icon.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "team-page" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "claim-your-space" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#joinUs"
}
const _hoisted_8 = { class: "team-btm-section" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "team-btm--inner" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "team-member--img" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "team-member--content" }
const _hoisted_15 = {
  key: 0,
  class: "load-more"
}
const _hoisted_16 = {
  class: "modal fade",
  id: "teamMembers",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  key: 0,
  class: "modal-dialog teamMember__modal",
  role: "document"
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "teammember_modal__inner" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_21 = { class: "teammember__details" }
const _hoisted_22 = { class: "teammember__img" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "teammember__content" }
const _hoisted_25 = { class: "teammember__info" }
const _hoisted_26 = {
  class: "teammember__des",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "member-pagination" }
const _hoisted_29 = {
  key: 0,
  class: "prev_member"
}
const _hoisted_30 = { class: "member_pagi_img" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "member_pagi_info" }
const _hoisted_33 = {
  key: 1,
  class: "next_member"
}
const _hoisted_34 = { class: "member_pagi_info" }
const _hoisted_35 = { class: "member_pagi_img" }
const _hoisted_36 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_jobForm = _resolveComponent("jobForm")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", {
          class: "team-top-section",
          style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/team-banner.jpg')})` })
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.constants['TEAM_TEXT']), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("i", null, [
                _hoisted_6,
                _createElementVNode("strong", null, _toDisplayString(_ctx.constants['CLAIM_YOUR_SPACE_LABEL']), 1)
              ]),
              _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.constants['JOIN_US_BUTTON']), 1)
            ])
          ])
        ], 4),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTeamData, (teamMember, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "team-member-box",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#teamMembers",
                  key: index,
                  onClick: ($event: any) => (_ctx.openTeamMemberModal(teamMember, index))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: _ctx.getCdnImageAddress(teamMember.teamMemberImage, `w_255,h_360/`),
                      alt: ""
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", null, _toDisplayString(teamMember.name), 1),
                    _createElementVNode("span", null, _toDisplayString(teamMember.designation), 1)
                  ])
                ], 8, _hoisted_11))
              }), 128))
            ]),
            (_ctx.displayedTeamData.length < _ctx.ourTeamData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("button", {
                    id: "loadMoreBtn",
                    class: "primary-btn-outline",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
                  }, "Load More")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.selectedTeamMember)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("img", {
                      src: _ctx.getCdnImageAddress(_ctx.selectedTeamMember.teamMemberImage, `w_255,h_360/`),
                      alt: ""
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.selectedTeamMember.name), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedTeamMember.designation), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.selectedTeamMember.description
                      }, null, 8, _hoisted_27)
                    ], 512)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.prevMember)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("button", {
                          class: "pagination-btns",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTeamMemberModal(_ctx.prevMember, (_ctx.currentIndex - 1 + _ctx.ourTeamData.length) % _ctx.ourTeamData.length)))
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("img", {
                              src: _ctx.getCdnImageAddress(_ctx.prevMember.teamMemberImage, `w_45,h_55/`) ,
                              alt: ""
                            }, null, 8, _hoisted_31)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.prevMember.name), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.prevMember.designation), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.nextMember)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("button", {
                          class: "pagination-btns",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openTeamMemberModal(_ctx.nextMember, (_ctx.currentIndex + 1) % _ctx.ourTeamData.length)))
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.nextMember.name), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.nextMember.designation), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("img", {
                              src: _ctx.getCdnImageAddress(_ctx.nextMember.teamMemberImage, `w_45,h_55/`) ,
                              alt: ""
                            }, null, 8, _hoisted_36)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_jobForm),
    _createVNode(_component_userFooter)
  ]))
}